module.exports = __webpack_public_path__ + "packs/media/images/climber_woman-8e1897d22941f1000452933012497d88.jpg";